module.exports = "/nonede890f9caec5ab77d9f7ff7c760e00ac.svg";